module.exports = __webpack_public_path__ + "67442278.png";